var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tabs',{on:{"tab-click":_vm.handleClick},model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('el-tab-pane',{attrs:{"label":"eBIRForms","name":"eBIRForms"}},[_vm._v("\n      "+_vm._s(_vm.msg)+"\n    ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }